module.exports = __webpack_public_path__ + "img/default-avata.355fcbf7.png";